import React, { Dispatch, useEffect, useRef, useState } from 'react';
import '../../../node_modules/react-grid-layout/css/styles.css'
import '../../../node_modules/react-resizable/css/styles.css'
import { IInjectInfo, IScenario, IHotwash, IGameStatus, IPlayer } from '../../interfaces';
import { HostSelection, Player } from '../../Classes1';
import { useAppDispatch } from '../../app/hooks'
import RGLHotwashInject from './RGLHotwashInject'
import _ from "lodash";
import Modal from 'react-modal';
import { updateHotwashSelection } from '../../features/hotwash/hotwashSlice'
import { Responsive, WidthProvider } from "react-grid-layout";
const RRGL = WidthProvider(Responsive);

interface Props {
  display: string;
  gameTimeInterval: number;
  isSelected: string;
  id: string;
  setInjectItem: Dispatch<any>;
  setZoomLevel: Dispatch<any>;
  zoomLevel: number;
  selectedScenario: IScenario;
  lastUserClick: string;
  setLastUserClick: Dispatch<any>;
  hotwashInjects: IInjectInfo[];
  setHotwashInjects: Dispatch<any>;
  hotwashStatus: IHotwash;
  injectItem: IInjectInfo;
  currentGame: IGameStatus;
  isHost: boolean;
  updateHotwashStatus: Dispatch<any>; 
  setShowHotwashTurnTimeline: Dispatch<any>;
  setShowHotwashNodeTimeline: Dispatch<any>;
}

//let eventListeners: string[] = [];

Modal.setAppElement('#root');

const RGLHotwash: React.FC<Props> = (props) => {

  let [openInject, setOpenInject] = useState<boolean>(false);
  const [layouts, setLayouts] = useState<{ [index: string]: any[] }>({});
  let [breakpoints, setBreakpoints] = useState<{ [index: string]: number }>({injects: (props.gameTimeInterval * 357)});
  const [selectedPlayer, setSelectedPlayer] = useState<IPlayer>(new Player());
  let dispatch = useAppDispatch()

  const lastUserClickRef = useRef<any>()
  useEffect(() => {
    lastUserClickRef.current = props.lastUserClick;
  });

  const layoutsRef = useRef<any>()
  useEffect(() => {
    layoutsRef.current = layouts;
  });

  const rglElements: any = document.querySelectorAll(".rgl-element");
  
  const onClickInject = (e: any) => {
      const target = e.target as HTMLElement;
      if (layouts.injects !== undefined && layouts.injects.length !== 0) {
        layouts.injects.forEach((inj: any) => {
            //const rglElem: HTMLElement | null = document.querySelector(".rgl-elem"+inj.handleId);
            let rglElem: any = {}
            for (let i=0; i<rglElements.length; i++) {
              if (rglElements[i].dataset.handleid === inj.i) {
                rglElem = rglElements[i] as HTMLElement
              }
            }
            //const rglElem = rglElements.filter((rglelem: any) => rglelem.dataset.handleId === inj.handleId)
            if (!_.isEmpty(rglElem)) {
              if (e.currentTarget.dataset.handleid === inj.i) {
                if (target) {
                  if (target.classList.contains('inject-more-detail')) {
                    
                    let myLayout = JSON.parse(JSON.stringify(layouts.injects))
                    for (let l = 0; l<myLayout.length; l++) {
                      if (myLayout[l].i === inj.i) {
                        const target = e.target as HTMLElement;

                        if (target) {
                          if (target.classList.contains('inject-more-detail')) {
                            props.hotwashInjects.forEach((inj: IInjectInfo) => {
                              if (inj.injectId === myLayout[l].i) {
                                props.setInjectItem(inj)
                              }
                            })
                            setOpenInject(true)
                            setSelectedPlayer(props.currentGame.players[0])
                          }
                        }
                      }
                    }
                  } else if (lastUserClickRef.current === inj.i) {
                    dblClickInject(inj.i)
                    //props.setLastUserClick('')
                    //controller.abort();
                  } else {
                    let parentInj = target.parentNode! as HTMLElement

                    if (!parentInj.classList.contains('unplayed')) {
                      props.setLastUserClick(inj.i)
                    }
                  }
                }
              }
            }
          
        })
      }
  }

  useEffect(() => {
    
    if (layouts.injects !== undefined && layouts.injects.length !== 0) {
      layouts.injects.forEach((inj: any) => {
          //const rglElem: HTMLElement | null = document.querySelector(".rgl-elem"+inj.handleId);
          let rglElem: any = {}
          for (let i=0; i<rglElements.length; i++) {
            if (rglElements[i].dataset.handleid === inj.i) {
              rglElem = rglElements[i] as HTMLElement
            }
          }
        
          if (!_.isEmpty(rglElem)) {
            if (rglElem.getAttribute('listener') !== 'true') {
                rglElem.setAttribute('listener', 'true');
                rglElem.addEventListener("mousedown", onClickInject)
              }
          }
      })
    }
  }, [layouts.injects, rglElements]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    if (props.hotwashInjects.length > 0) {
        let injObjs: any = []

        for (let i = 0; i<props.hotwashInjects.length; i++) {
          let injObj: any = {};
          injObj.i = props.hotwashInjects[i].injectId
          injObj.text = props.hotwashInjects[i].injectId
          injObj.x = props.hotwashInjects[i].startTurn - 1;
          injObj.y = props.hotwashInjects[i].turnOrder! - 1;
          injObj.w = props.hotwashInjects[i].turnLength;
          injObj.h = 1;
          injObj.static = true;
          injObj.isResizable = false;
          injObj.handleId = "inject"+i
          injObjs.push(injObj)
        }

        if (props.zoomLevel === 5) {
          RRGL!.defaultProps!.rowHeight = 28;
          RRGL!.defaultProps!.containerPadding = [0, 32];
          //setRowHeight(28)
          setBreakpoints({injects: (props.gameTimeInterval * 184)})
        } else {
          RRGL!.defaultProps!.rowHeight = 56;
          RRGL!.defaultProps!.containerPadding = [0, 66];
          //setRowHeight(28)
          setBreakpoints({injects: (props.gameTimeInterval * 357)})
        }
        
        RRGL!.defaultProps!.cols = { injects: props.gameTimeInterval };

        setLayouts({injects: injObjs})
      }
  }, [props.hotwashInjects, props.zoomLevel, props.gameTimeInterval])

  const dblClickInject = async (injectId: string) => {
        props.hotwashInjects.forEach((inject) => {
          if (inject.injectId.toString() === injectId) {
            props.setShowHotwashNodeTimeline('show')
            props.setShowHotwashTurnTimeline('hide')
            props.setInjectItem(inject)
            props.setZoomLevel(3)
          }
        });
        let newHostSelection: any = {};
        newHostSelection.hotwashId = props.hotwashStatus.gameId;
        newHostSelection.hostSelection = new HostSelection();
        
        newHostSelection.hostSelection.page = '';
        newHostSelection.hostSelection.turn = props.hotwashStatus.currentSelection.turn;
        newHostSelection.hostSelection.inject = injectId;
        newHostSelection.hostSelection.node = '';
        newHostSelection.hostSelection.nodeTab = '';
        newHostSelection.hostSelection.nodePlayerID = '';
        await dispatch(updateHotwashSelection(newHostSelection))
        props.updateHotwashStatus(props.hotwashStatus.gameId)
  }

  const generateDOM = () => {
    return _.map(layouts.injects, function(l, i) {
      return (
        <div key={l.i} className={`rgl-elem${l.handleId} rgl-element`} data-handleid={l.i}>
          <RGLHotwashInject isSelected={l.i === props.lastUserClick ? 'selected' : ''} setInjectItem={props.setInjectItem} id={l.i} key={l.i} zoomLevel={props.zoomLevel} setZoomLevel={props.setZoomLevel} turn={l.x+1} hotwashInjects={props.hotwashInjects} hotwashStatus={props.hotwashStatus} y={l.y} injectItem={props.injectItem} currentGame={props.currentGame} isHost={props.isHost} updateHotwashStatus={props.updateHotwashStatus} openInject={openInject} setOpenInject={setOpenInject} selectedPlayer={selectedPlayer} setSelectedPlayer={setSelectedPlayer} />
        </div>
      )
    })
  }

  const onBreakpointChange = (breakpoint: string) => {
    //setCurrentBreakpoint(breakpoint)
  };

  const onLayoutChange = (layout: any) => {
    console.log("hotwash Layout: ", layout)
    //props.setSaveLayouts({ injects: layout })
  };

  const onDrop = (layout: any, layoutItem: any, _event: any) => {
    console.log(`Dropped element props:\n${JSON.stringify(layoutItem, ['x', 'y', 'w', 'h'], 2)}`);
  };

  return (
      <div className={`react-grid visible rgl-grid`} style={{ display: 'block', width: breakpoints.injects }}>
        <RRGL
          {...props}
          style={{ background: "none" }}
          layouts={layouts}
          breakpoints={breakpoints}
          measureBeforeMount={false}
          useCSSTransforms={true}
          compactType={"vertical"}
          preventCollision={false}
          isResizable={true}
          onLayoutChange={onLayoutChange}
          onBreakpointChange={onBreakpointChange}
          onDrop={onDrop}
          isDraggable={true}
          isDroppable
        >
          {generateDOM()}
        </RRGL>
      </div>
    );
}

/*if (process.env.STATIC_EXAMPLES === true) {
  import("../test-hook.jsx").then(fn => fn.default(DragFromOutsideLayout));
}*/

export default RGLHotwash;

RRGL.defaultProps = {
  className: "layout",
  onLayoutChange: (layout: any) => {},
  cols: { injects: 8 },
  containerPadding: [0, 66],
  rowHeight: 56
};

